const CalendarPage = () => import('@/pages/calendar/CalendarPage');

export default [
  {
    path: '/calendar',
    component: CalendarPage,
    meta: {
      layout: 'CalendarLayout',
    },
    children: [
      {
        path: ':task_id',
        component: CalendarPage,
        meta: {
          layout: 'CalendarLayout',
        },
      },
    ],
  },
];
